export default {
  ARCHIVED: 'Arhiveeritud',
  NEW: 'UUS',
  NEW_PASSWORD: 'Sisesta uus parool',
  REPEAT_NEW_PASSWORD: 'Korda uut parooli',
  PASSWORD_IS_REQUIRED: 'Parool on nõutud',
  PASSWORDS_MUST_MATCH: 'Paroolid peavad kattuma',
  PASSWORD_CHANGED_SUCCESSFULLY: 'Parool muudetud edukalt',
  INFORMATION: 'Informatsioon',
  SERVICE: 'Teenus',
  STATUS: 'Staatus',
  EXTEND_TIME: 'Pikenda aega',
  TIME_EXTENDED: 'Aeg pikendatud!',
  NEW_CLIENTS_ONLY: 'Ainult uued kliendid',
  ONE_TIME_DISCOUNT: 'Ühekordne soodustus',
  PAYMENT_METHOD_REQUIRED: 'Maksemeetod kohustuslik',
  GENERATE_ONE_TIME_PROMO_CODES: 'Ühekordsed promokoodid',
  ICON_FOR_APP: 'Ikoon äpi jaoks',
  SELECT_CAMPAIGN: 'Vali kampaania',
  WHICH_WILL_BE_VALID_FOR: 'Mis kehtib',
  AFTER: 'Pärast',
  DAYS: 'päeva',
  ACTIVATE: 'Aktiveeri',
  CREATE_NEW_CAMPAIGN: 'Loo uus kampaania',
  ACTIVATE_NEW_CAMPAIGN: 'Aktiveeri uus kampaania',
  PROMO_CODES: 'Promokoodid',
  CREATE_NEW_PROMO_CODES: 'Loo uued promokoodid',
  AMOUNT_OF_NEW_CODES: 'Arv uusi koode',
  DETAILS: 'Detailid',
  COPY: 'Kopeeri',
  RESET_PASSWORD: 'Taasta parool',
  COPY_PASSWORD_RESET_LINK: 'Kopeeri taastamise link',
  LOGIN_AS_THIS_USER: 'Logi sisse selle kasutajana',
  ACTIVE_SESSION: 'Aktiivne sessioon',
  ACTIVE_SESSIONS: 'Aktiivset sessiooni',
  VERIFIED: 'Kinnitatud',
  LOCATIONS: 'Asukohad',
  ZONES: 'Tsoonid',
  PLEASE_BE_PATIENT: 'Palun ole kannatlik...',
  SELECT_ZONE: 'Vali tsoon',
  SELECT_PLACE: 'Vali asukoht',
  FILTERS: 'Otsing',
  ADD_NEW_USER: 'Lisa uus kasutaja',
  ADD_USER_SLASH_COMPANY: 'Lisa kasutaja/ettevõte',
  EDIT_USER_SLASH_COMPANY: 'Muuda kasutajat/ettevõtet',
  ACCESS_TO_PLATFORM: 'Ligipääs keskkonda',
  CAN_VEW_PARKING_FINES: 'Ligipääs trahvidele',
  ENFORCEMENT_APP_ENABLED: 'Ligipääs trahvi äpile',
  IS_NEW_TENANT: 'Loo üürnikule uus kasutajaluba',
  NAME_IS_REQUIRED: 'Nimi on nõutud',
  EMAIL_IS_REQUIRED: 'Email on nõutud',
  IN_PLACES: 'Asukohas',
  IN_ZONES: 'Tsoonis',
  EXPIRED: 'Aegunud',
  ACTIVE: 'Aktiivne',
  ACTIVE_PLURAL: 'Aktiivset',
  DOWNLOAD_TEMPLATE_FILE: 'Lae alla näidis',
  HOME: 'Kodu',
  TITLE: 'Pealkiri',
  MESSAGE: 'Sisu',
  SESSION: 'Sessioon',
  COST_IN_EUROS: 'Maksumus eurodes',
  INVOICES: 'Arved',
  noDataText: 'Andmed puuduvad',
  YES: 'Jah',
  NO: 'Ei',
  CANCEL: 'Katkesta',
  CAN_NOT_BE_UNDONE: 'Seda ei saa tagasi võtta',
  SEARCH_BY_NAME: 'Otsi nime järgi...',
  PREVIEW: 'Eelvaade',
  ARE_YOU_SURE: 'Oled sa kindel?',
  COUNTRY_CODE: 'Riigikood',
  LOADING_NEW_CONTENT: 'Laen uut sisu...',
  NEW_CONTENT_AVAILABLE: 'Uuenenud sisu saadaval.',
  REFRESH: 'VÄRSKENDA',
  YEAR: 'Aasta',
  MONTH: 'Kuu',
  EDIT: 'Muuda',
  ADD: 'Lisa',
  DELETE: 'Kustuta',
  SAVE: 'Salvesta',
  LOG_OUT: 'Logi välja',
  LOG_IN: 'Logi sisse',
  BACK: 'Tagasi',
  CLOSE: 'Sulge',
  LIST_EMPTY: 'Nimekiri tühi',
  PREVIOUS: 'Eelmised',
  NEXT: 'Järgmised',
  PAGE: 'Lehekülg',
  SHOW: 'Näita',
  MONDAY: 'Esmaspäev',
  TUESDAY: 'Teisipäev',
  WEDNESDAY: 'Kolmapäev',
  THURSDAY: 'Neljapäev',
  FRIDAY: 'Reede',
  SATURDAY: 'Laupäev',
  SUNDAY: 'Pühapäev',
  CURRENCY: 'Valuuta',
  TOTAL: 'Kokku',
  COUNT: 'Arv',
  VALID_FROM: 'Kehtib alates',
  VALID_TO: 'Kehtib kuni',
  DESCRIPTION: 'Kirjeldus',
  IMPORT_FROM_FILE: 'Faili import',
  INVITE_FROM_FILE: 'Saada kutsed failist',
  SEARCH: 'Otsi',
  EXPORT_TO_EXCEL: 'Excel väljavõte',
  COMMENTS: 'Kommenaarid/info',
  CLIENT_ID: 'Kliendi id',
  PHONE_NUMBER: 'Telefoninumber',
  CAR_NUMBER: 'Numbrimärk',
  CLIENT_ACTIVE_CAR_NUMBER: 'Kliendi aktiivne numbrimärk',
  EMAIL: 'E-mail',
  NAME: 'Nimi',
  LOCATION: 'Asukoht',
  START_TIME: 'Algusaeg',
  END_TIME: 'Lõpuaeg',
  INVALID_DATE: 'Vigane kuupäev',
  INVALID_TIME: 'Vigane kellaaeg',
  COST: 'Tasu',
  TYPE: 'Tüüp',
  REGION: 'Regioon',
  ZONE: 'Tsoon',
  OPERATOR: 'Operaator',
  GENERATE: 'Genereeri',
  SEND_TO_EMAIL: 'Saada e-mailile',
  EMAIL_REQ_INFO: 'Kinnitamata kliendi emaili sisu',
  CODE: 'Kood',
  ERROR_GLOBAL: 'Midagi läks valesti! Palun proovige hiljem uuesti.',
  EMAIL_REG_REQ_INFO:
    "Emaili sisu kui 'Kinnita-automaatselt' on välja lülitatud",
  COMMENTS_FOR_ENFORCEMENT: 'Kommentaar parkimisjärelevalvele',
  PARKING_ACTIVE: 'Pargib',
  PARKING_NOT_ACTIVE: 'Ei pargi',
  WITH_BOOKING: 'Broneeringuga',
  WITHOUT_BOOKING: 'Ilma broneeringuta',
  PARKING_SESSIONS_OVER_FREE_TIME: 'Üle tasuta aja parkijad',
  EXTRA_FILTER: 'Lisafilter',
  HEADER: {
    LANGUAGE: 'Keel'
  },
  EMPTY_STATE: {
    WHITELIST_EMPTY_HERE: 'Siin on tühjus',
    WHITELIST_EMPTY_HERE_MESSAGE: 'Teil ei ole ühtegi kasutajaluba',
    FLEETS_EMPTY_HERE: 'Siin on tühjus',
    FLEETS_EMPTY_HERE_MESSAGE:
      'Teil ei ole ühtegi külastajat või teil puuduvad vastavad õigused',
    USERS_EMPTY_HERE: 'Siin on tühjus',
    USERS_EMPTY_HERE_MESSAGE:
      'Teil ei ole ühtegi kasutajat või Teil puuduvad õigused kasutajatele',
    WHITELISTS_VEHICLE_NUMBER_SEARCH_NO_RESULTS:
      'Antud autonumber ei kuulu hetkel ühegi kasutajagrupi alla',
    FLEETS_VEHICLE_NUMBER_SEARCH_NO_RESULTS:
      'Antud autonumber ei kuulu hetkel ühegi külalisloa alla'
  },
  ALLOWED_TO_CALL: {
    TITLE: 'Isikud, kes võivad telefonikõnega tõkkepuud avada',
    PHONE_NUMBER: 'Telefon',
    CAR_NUMBER: 'Auto',
    NAME: 'Nimi',
    APP: 'Äpp',
    VALID_UNTIL: 'Kuni',
    INVALID_INPUTS: 'Telefoninumber ja auto number peavad olema täidetud',
    CALLS: 'Logi',
    CHARGE_FOR_SESSIONS: 'Tasuline'
  },
  DASHBOARD: {
    TITLE: 'Töölaud',
    DESCRIPTION: 'Kõik kasutajalubade ja külastajate sessioonid',
    PLACES_TITLE: 'Asukohad',
    PLACES_DESCRIPTION: 'Kõik sinu hallatavad asukoad.',
    ADDRESS: 'Aadress',
    THIS_MONTH_REVENUE: 'Selle kuu käive',
    LAST_MONTH_REVENUE: 'Eelmise kuu käive',
    CHANGE_ALLOWED_TO_CALL: 'Muuda telefonikõnega värava avajate nimekirja',
    SESSIONS_TITLE: 'Parkimised',
    SESSIONS_DESCRIPTION: 'Kõik sessionid sinu aukohtades.',
    GENERAL_FILTERS: 'Filtrid',
    CAR_NUMBER: 'Auto',
    RESERVATION_TIME: 'Reserveeringu aeg',
    START_TIME: 'Algusaeg',
    END_TIME: 'Lõpuaeg',
    STATUS: 'Staatus',
    COST: 'Hind',
    CLIENT: 'Klient',
    CLIENTS_PHONE: 'Kliendi telefoninumber',
    CLIENTS_NAME: 'Kliendi nimi',
    PLACE: 'Asukoht',
    PAYMENT_INFO: 'Makse info',
    PAID_WITH_MONTHLY_PASS: 'Makstud kuupiletiga',
    PAID_WITH_CREDITCARD: 'Makstud krediitkaardiga',
    WHITELISTED: 'Eriloaga',
    PLACE_NAME: 'Koha nimi',
    SEARCH: 'Otsing',
    UTILIZATION: 'Hõivatud',
    PAYMENT_FROM: 'Alates',
    PAYMENT_TO: 'Kuni',
    SUMMARY: 'Kokkuvõte',
    REVENUE: 'Käive',
    MONTHLY_PASSES_REVENUE: 'Kuukaardid',
    OWNERS_SHARE: 'Omaniku osa',
    PHONE_CALL: 'Telefonikõne',
    RFID: 'RFID',
    INVOICE: 'Arve',
    PAYMENT_LOGS: 'Makselogid',
    CREDIT: 'Krediit',
    WHITELISTS: 'Kasutajaload',
    FLEETS: 'Külalised',
    CAMPAIGNS: 'Kampaaniad',
    CAMPAIGN_CODE: 'Kampaaniaakoood',
    REG_LIMIT: 'Reg. limiit',
    REGISTRANTS: 'Registrandid',
    NO_ACTIVE_CAMPAIGNS: 'Aktiivsed kampaaniad puuduvad',
    PAYOUTS: 'Väljamaksed',
    USERS: 'Kasutajad',
    USERS_DESCRIPTION: 'Kõik sinu hallatavad kasutajad',
    CAMPAIGN_DESCRIPTION: 'Kõik sinu kampaaniad',
    START_SESSION: 'Alusta parkimist',
    REPORTS: 'Raportid',
    TYPES: 'Tüüp:',
    REGIONS: 'Regioon:',
    ZONES: 'Tsoon:',
    OPERATORS: 'Operaator:',
    IMPORT_FROM_FILE: 'Faili import',
    ADD_NEW_LOCATION: 'Lisa uus asukoht',
    CONTROLLER: 'Kontroller',
    STATISTICS: 'Statistika',
    MONTHLY_PASSES: 'Kuukaardid',
    WHITELIST: 'Whitelist',
    EVENTS: 'Sündmused',
    LPR: 'Numbrituvastus',
    DEAL_TIMELOG: 'Kulud',
    SETTINGS: 'Seaded',
    SETTINGS_DESCRIPTION: 'Kõik sinu seaded',
    DAY_PASSES: 'Sissesõiduload',
    BOOKING: 'Broneerimine',
    KIOSKS: 'Kioskid'
  },
  CONTROLLERS: {
    REFRESH: 'Värskenda',
    CONTROLLER_LOGS: 'Kontrolleri logid',
    FIRMWARE: 'Tarkvara',
    FIRMWARE_UPDATE: 'Tarkvara uuendus',
    UPDATE_FIRMWARE: 'Uuenda tarkvara',
    FIRMWARE_VERSION: 'Tarkvara versioon',
    FIRMWARE_VERSION_INFORMATION_TITLE: 'Informatsioon tarkvara kohta',
    VERSION: 'Versioon',
    REASON: 'Põhjus',
    ADDITIONAL_REASON_CODE: 'Additional reason code',
    ADDITIONAL_REASON_TEXT: 'Additional reason text',
    OTA_NOTIFICATION_DESCRIPTION:
      'Hetkel ei ole võimalik uuendada üle õhu tarkvara, mis algab numbritega 1.1.',
    CLOSED: 'SULETUD',
    OPENED: 'AVATUD',
    ADD_CONTROLLER: 'Lisa controller',
    EDIT_CONTROLLER: 'Muuda controllerit'
  },
  EDIT_PLACE: {
    SCHEDULE_VALIDITY: {
      TITLE: 'Graafiku kehtivus',
      FROM: 'Algus',
      TO: 'Lõpp',
      UNLIMITED: 'Piiramata'
    },
    RENTAL_SCHEDULE: {
      TITLE: 'Väljarentimise ajad',
      COPY_MONDAY_SCHEDULE: 'Kopeeri esmaspäeva graafik kõigile päevadele',
      SPOTS: 'kohta',
      OTHER_TIMES: 'Ülejäänud aeg',
      IS_CLOSED: 'Suletud'
    },
    MONTHLY: {
      TITLE: 'Perioodiline kuukaart',
      ENABLED: 'Lubatud',
      MONTHLY_COST: 'Kuu hind',
      MAX_NUM: 'Saadaval',
      NOTIFICATION_EMAILS: 'Teavituse emailid',
      DESCRIPTION_FOR_APP: 'Kirjeldus äppi',
      NO_ACTIVE_MONTHLY_PASSES: 'Aktiivsed kuukaardid puuduvad',
      NO_EXPIRED_MONTHLY_PASSES: 'Aegunud kuukaardid puuduvad',
      UPDATED: 'Kuukaart uuendatud edukalt',
      ADDED: 'Kuukaart lisatud edukalt'
    }
  },
  LOGIN: {
    EMAIL: 'E-mail',
    PASSWORD: 'Parool',
    INVALID_INPUTS: 'Vale e-mail või parool.',
    FORGOT_PASSWORD: 'Unustasid parooli?',
    FORGOT_PASSWORD_TITLE: 'Unustasin parooli',
    SUBMIT: 'Saada'
  },
  REGISTER: {
    REGISTER: 'Registreeru',
    NAME: 'Nimi',
    EMAIL: 'E-mail',
    PHONE_NUMBER: 'Telefoninumber',
    PASSWORD: 'Parool',
    PASSWORD_AGAIN: 'Parool uuesti'
  },
  STATISTICS: {
    TITLE: 'Statistika',
    SHOW: 'Näita',
    SHOW_LOG: 'Näita logi',
    FROM: 'Alates',
    TO: 'Kuni',
    WITH_APP: 'Äpiga',
    WITHOUT_APP: 'Ilma äpita',
    TOTAL_SESSIONS: 'Kõik sessioonid',
    TIMESTAMP: 'Aeg',
    EVENT: 'Sündmus',
    SESSIONS_PER_DAY: 'Parkimissessioone päevas',
    TIME_OF_DAY: 'Päev',
    PARKING_SESSIONS: 'Parkimissessioonid',
    GROUP_BY_CAR: 'Grupeeri autonr. järgi',
    SELF_PAID_PARKING_SESSIONS: 'Ise makstud parkimised'
  },
  WHITELISTS: {
    TITLE: 'Kasutajagrupid',
    REGION: 'Regioon',
    NAME: 'Nimetus',
    VALID_IN: 'Kus kehtib',
    APPROVED_USERS: 'Kinnitatud kasutajad',
    PENDING_USERS: 'Kinnitamata kasutajad',
    ADD_NEW: 'Lisa uus',
    WITH_AVAILABILITY_INFO: 'Koos saadavusega',
    ACTIVE_USERS: 'Aktiivsed kasutajad',
    INACTIVE_USERS: 'Mitteaktiivsed kasutajad'
  },
  EDIT_WHITELISTS: {
    ADD_NEW_WHITELIST: 'Lisa uus kasutajaluba',
    EDIT_WHITELIST: 'Muuda kasutajaluba',
    DETAILS: 'MUUTMINE',
    USERS: 'Kasutajad',
    SESSIONS: 'PARKIMISED',
    NAME: 'Nimetus',
    APP: 'App',
    REGION: 'Regioon',
    VALID_IN: 'Kus kehtib',
    REGISTRATION_ALLOWED_UNTIL: 'Registreemine lubatud kuni',
    REG_CODE_FOR_APP: 'Registreerimiskood äpis',
    AUTO_APPROVE: 'Kinnita kasutajad automaatselt',
    ONE_TIME_CODES: 'Ühekordsed promokoodid',
    REG_NOTIFICATION_EMAILS: 'E-mailid teavitusteks',
    ADD_MANAGER: 'Lisa haldur',
    PUBLIC_REG_LINK: 'Avalik registreerimislink',
    MANAGERS: 'Haldurid',
    NO_MANAGERS: 'Haldurid puuduvad',
    CHARGE_FOR_SESSIONS: 'Võta parkimistelt tasu',
    START_SESSIONS_WITH_LPR: 'Alusta numbrituvastusega',
    START_SESSIONS_WITH_LPR_DESCRIPTION:
      'Sessioon alustatakse automaatselt, kui on paigaldatud numbrituvastussüsteem.',
    AVAILABILITY_AND_PRICING: 'Graafik ja hinnastus',
    MANAGE_AVAILABILIY_AND_PRICING: 'Muuda graafikut ja hinnastust',
    EMAIL_INFO_AFTER_APPROVAL: 'Emaili sisu peale edukat registreerumist',
    WHITELIST_USERS: 'Kasutajate haldamine',
    INVITE: 'Saada kutse',
    ADD_NEW: 'Lisa uus',
    PHONE_NUMBER: 'Telefoninumber',
    CAR_NUMBERS: 'Numbrimärgid',
    USER_NAME: 'Nimi',
    EMAIL: 'E-mail',
    REG_TYPE: 'Reg. tüüp',
    REG_TIME: 'Reg. aeg',
    COMMENTS: 'Kommentaar',
    STATUS: 'Staatus',
    ACTIVE_SESSIONS: 'Aktiivsed parkimised',
    SESSION_ID: 'Parkimise ID',
    LOCATION: 'Asukoht',
    CAR_NUMBER: 'Numbrimärk',
    START_TIME: 'Algusaeg',
    END_TIME: 'Lõpuaeg',
    OVERTIME_MINUTES: 'Üleaeg minutites',
    OVER_ALLOWED_SPOTS_LIMIT_MINUTES:
      'Üle lubatud kohtate arvu pargitud aeg minutites',
    OVER_ALLOWED_SPOTS_LIMIT_NUMBER_OF_PARKING_SESSIONS:
      'Üle lubatud kohtate arvu parkimiste arv',
    REPORT: 'Raport',
    TYPE: 'Raportitüüp',
    SESSIONS_COUNT: 'Parkimiste arv',
    PARKED_MINUTES: 'Pargitud minuteid',
    COST: 'Tasu',
    NO_ACTIVE_SESSIONS: 'Aktiivsed parkimised puuduvad',
    SELECT_WHITELIST: 'Vali kasutajaluba',
    MAX_NUMBER_OF_VEHICLES: 'Maksimaalne kasutajate/sõidukite arv',
    DEFAULT_MAX_NUMBER_OF_VEHICLES_FOR_REGISTERED_CLIENT:
      'Vaikimisi maksimaalne sõidukite arv registreeritud kliendil',
    PLACE_REQUIRED:
      'Asukoha valimine kohustuslik kui valitud on kehtivus "Asukohas"',
    ZONE_REQUIRED:
      'Tsooni valimine kohustuslik kui valitud on kehtivus "Tsoonis"',
    MAX_NUMBER_OF_USER_VEHICLES: 'Maksimaalne sõidukite arv',
    USE_OWN_AVAILABILITY_AND_PRICING: 'Kasuta oma graafikut ja hinnastust',
    ALLOW_PARKING_WITH_NO_SPOTS: 'Luba alustada parkimist, kui vabu kohti pole',
    ADD_TO_FAVORITES: 'Lisa lemmikuks',
    REMOVE_FROM_FAVORITES: 'Eemalda lemmikutest',
    ADDED_TO_FAVORITES: 'Kasutajagrupp on lisatud lemmikuks',
    REMOVED_FROM_FAVORITES: 'Kasutajagrupp on eemaldatud lemmikutest',
    EXPIRATION_WARNING_TITLE: 'See muudatus mõjutab {0} kasutajat',
    EXPIRATION_WARNING_TITLE_ONE: 'See muudatus mõjutab 1 kasutajat',
    EXPIRATION_WARNING_BODY:
      'Mõnel kasutajal on hetkel kasutajagrupist hilisem kehtivusaeg. Nende ligipääs lõpeb {0}, kui kasutajagrupi kehtivusaega ei pikendata.'
  },
  AVAILABILITY_TABLE: {
    TITLE: 'Saadavusgraafik ja hinnad',
    SUB_TITLE: 'NB! Hinnad käibemaksuta',
    '24H_COST': '24h tasu',
    OTHER_TIMES: 'Ülejäänud ajal',
    NUMBER_OF_SPOTS: 'Lubatud parkijate arv',
    HOURLY_RATE: 'Tunnihind',
    MIN_COST: 'Miinimumtasu',
    MAX_COST: 'Maksimumtasu'
  },
  FLEETS: {
    TITLE: 'Külastajad',
    ADD_NEW: 'Lisa uus',
    REGION: 'Regioon',
    NAME: 'Nimetus',
    TYPE: 'Tüüp',
    REG_CODE: 'Reg. kood',
    USERS_LIMIT: 'Lubatud kasutajate arv',
    USERS: 'Kasutajaid',
    REPORT: 'Raportid',
    DEFAULT_MINUTES_INFORMATION:
      'Valitud asukohale on määratud vaikimisi parkimise minutid:'
  },
  EDIT_FLEETS: {
    TITLE: 'Külastajad',
    NAME: 'Nimetus',
    TYPE: 'Tüüp',
    REGION: 'Regioon',
    VALID_IN: 'Kus kehtib',
    APP: 'Äpp',
    DEF_DAILY_LIMIT: 'Vaikimis päevalimiit',
    DEF_MONTHLY_LIMIT: 'Vaikimisi kuulimiit',
    MAX_NUMBER_OF_USERS: 'Lubatud kasutajate arv',
    RESET_LIMITS: 'Nulli limiidid iga kuu alguses',
    REG_OPEN_TIL: 'Registreerimine aktiivne kuni',
    REG_CODE_APP: 'Kood äpis aktiveerimiseks',
    AUTO_APPROVE: 'Kinnita kasutajad automaatselt',
    ONE_TIME_PROMO_CODES: 'Ühekordsed äpikoodid registreerimiseks',
    REG_NOTIFICATION_EMAIL: 'Email teavituseks',
    PUBLIC_REG_LINK: 'Avalik registreerimislink',
    START_WITH_LPR: 'Alusta parkimine numbrituvastusega',
    ADD_MANAGER: 'Lisa haldur',
    MANAGERS: 'Haldurid',
    NO_MANAGERS: 'Haldurid puuduvad',
    EMAIL_BODY_AFTER_REGISTRATION: 'Emaili sisu peale edukat registeerumist',
    DESC_FOR_APP: 'Kirjeldus, mis kuvatakse äpis',
    PHONE_NUMBER: 'Telefoninumber',
    CAR_NUMBER: 'Numbrimärk',
    USER_NAME: 'Nimi',
    EMAIL: 'E-mail',
    DAILY_LIMIT: 'Päevalimiit',
    MONTHLY_LIMIT: 'Kuulimiit',
    REG_TYPE: 'Reg. tüüp',
    REG_TIME: 'Reg. aeg',
    STATUS: 'Staatus',
    INVITE: 'Saada kutse',
    ADD_NEW: 'Lisa uus',
    FLEET_USERS: 'Kasutajaid',
    SELECT_FLEET: 'Vali külalisgrupp',
    ADD_NEW_FLEET: 'Lisa uus külalisgrupp',
    EDIT_FLEET: 'Muuda külalisgruppi',
    PLACE_REQUIRED:
      'Asukoha valimine kohustuslik kui valitud on kehtivus "Asukohas"',
    ZONE_REQUIRED:
      'Tsooni valimine kohustuslik kui valitud on kehtivus "Tsoonis"'
  },
  FLEET_REPORT: {
    LIMIT: 'Kuu limiit:',
    USED_TOTAL: 'Kasutatud:',
    DAILY_LIMIT: 'Päevalimiit',
    MONTHLY_LIMIT: 'Kuulimiit',
    USED_FLEET_CREDIT: 'Kasutatud krediit',
    AVAILABLE_FLEET_CREDIT: 'Saadaval krediit',
    OVER_LIMIT: 'Üle limiidi',
    SELF_PAID: 'Ise makstud'
  },
  REPORTS: {
    TITLE: 'Raportid',
    DESCRIPTION: 'Kõik raportid',
    REPORT_TYPE: 'Raporti tüüp',
    GROUP_BY: 'Grupeeri'
  },
  ADD_SESSION: {
    TITLE: 'Lisa parkimine',
    HOURS: 'Tunnid',
    DAYS: 'Päevad',
    MINUTES: 'Minutid'
  },
  ENFORCEMENT: {
    ENFORCER: 'Järelvalvaja',
    ENFORCEMENT: 'Järelvalve',
    REASON: 'Põhjus',
    ADDITIONAL_REASON_CODE: 'Lisa põhjus(kood)',
    ADDITIONAL_REASON_TEXT: 'Lisa põhjus(tekst)',
    CREATED_AT: 'Väljastatud',
    LOOK_IMAGES: 'Vaata pilte',
    MARK_AS_PAID: 'Märgi trahv makstuks',
    CANCEL_FINE: 'Tühista trahv',
    FINE_PAYMENT_DATE: 'Trahv maksti kuupäeval',
    NO_IMAGES_TO_SHOW: 'Pildid puuduvad (ühtegi pilti pole tehtud)',
    PAID_AMOUNT: 'Makstud trahvisumma',
    OVERDUE: 'üle aja',
    EDIT_PARKING_FINE: 'Muuda trahvi',
    VEHICLE_NUMBER_COUNTRY: 'Sõiduki registreerimisriik',
    LOCATION: 'Asukoht',
    ISSUER_NAME: 'Väljastaja',
    PARKING_FINES: 'Parkimistrahvid',
    PAYMENT_DATE_REQUIRED: 'Trahvi maksmis kuupäev on nõutud',
    PAID_AMOUNT_REQUIRED: 'Makstud summa on nõutud',
    DEBTS_SENT: 'Edastatud inkassole',
    DEBTS_SENT_YES: 'JAH',
    DEBTS_SENT_NO: 'EI',
    DEBT_INCOMES: 'Märgi laekumine',
    AMOUNT_RECEIVED: 'Laekunud summa',
    RECEIVED_INCOME_DATE: 'Laekumise kuupäev',
    MARK_RECEIVED_INCOME: 'Laekumise märkimine',
    INCOMES: 'Laekumised',
    DOWNLOAD_PARKING_FINE_PDF: 'Lae alla PDF',
    ID: 'Id',
    VOID_TIME: 'Void time',
    PARKING_FINE: 'Parkimistrahv',
    ALSO_CREATE_NEW_FINE: 'Lisaks loo ka uus trahv',
    LAST_AMOUNT: 'Viimane tasu',
    PARKING_FINE_INVOICES: 'Arve',
    PARKING_FINE_INVOICE_NUMBER: 'Number',
    PARKING_FINE_INVOICE_DATE: 'Kuupäev',
    PARKING_FINE_AMOUNT: 'Summa',
    COMMENTS: 'Kommentaarid',
    COMMENT: 'Kommentaar',
    NO_COMMENTS: 'Kommentaarid puuduvad...',
    REFERENCE_NUMBER: 'Viitenumber',
    PARKING_FINE_PROFILE_BENEFICIARY: 'Väljastaja',
    SEND_FINE_TO_JULIANUS: 'Edasta inkassole',
    RESET_PARKING_FINE: 'Taasta trahvi algseis',
    DO_NOT_FORWARD_DEBTS: 'Ära edasta inkassole',
    HAS_SENT_APPEAL: 'Vaie esitatud',
    PARKING_FINE_UPDATED_SUCCESSFULLY: 'Trahv uuendatud edukalt',
    DEBTS_WILL_BE_FORWARDED_AT: 'Inkassole edastamine pikendatud kuni:',
    PARKING_STATUS_CHECK_LOGS: 'Kontrollimised',
    CHECKED_AT: 'Kontrollitud',
    HAD_PARKING: 'Parkimine',
    INCOME_RECEIVED_VIA_CHANNEL: 'Kanal',
    INCOME_INSERTER: 'Sisestaja',
    INCOME_RECEIVED_AT: 'Summa laekus kuupäeval',
    FORWARD_DEBTS_AT: 'Edasta inkassosse kuupäeval/lükka edastust edasi',
    COMMENTS_REQUIRED: 'Kommentaar on kohustuslik',
    PARKING_FINE_REPORTS: {
      TITLE: 'Automatiseeritud raportid',
      EDIT: 'Muuda',
      ADD_NEW: 'Lisa uus kirje',
      EMAIL_TO: 'Saaja meiliaadress(id)',
      EMAIL_BCC: 'Kaassaaja meiliaadress(id)',
      SENDING_DAYS: 'Päevad, millal genereerida/saata iga kuu',
      IS_MONTHLY_REPORTING_ENABLED: 'Sisse lülitatud',
      NEW_VEHICLE_GROUP_NAME: 'Uue grupi nimi',
      NEW_VEHICLE_GROUP_NAME_IS_REQUIRED: 'Uue autogrupi nimi on nõutud',
      VEHICLE_LIST: 'Autonumbri nimekiri',
      NEW_TASK_ADDED_SUCCESSFULLY: 'Uus automatiseeritud raprot lisatud edukalt'
    },
    ENFORCEMENT_OFFICERS: {
      TITLE: 'Kontrolörid',
      ADD_NEW_OFFICER: 'Lisa uus kontrolör',
      EDIT_OFFICER: 'Muuda kontrolöri andmeid',
      EMAIL: 'E-mail',
      PASSWORD: 'Parool',
      OFFICER_NAME: 'Nimi',
      GROUP: 'Grupp'
    },
    PARKING_FINE_PLATFORM_URL: 'Parkimistrahvi platvormi link',
    PENALTY_APPEAL_COMMENTS: 'Vaidemenetluse kommentaarid',
    PENALTY_APPEAL_COMMENTS_ADD: 'Lisa vaidemenetluse kommentaarid',
    COMMENTS_TOO_LONG: 'Kommentaarid ei tohi olla pikemad kui 1024 tähemärki',
    REGION: 'Regioon'
  },
  SETTINGS: {
    OPERATOR_SETTINGS: 'Operaatori seaded',
    OPERATOR_SETTINGS_DESCRIPTION: 'Kõik sinu operaatori seaded',
    ADD_NEW_ZONE: 'Lisa uus tsoon',
    NO_ZONES: 'Tsoonid puuduvad',
    CHOOSE_ICON: 'Vali ikoon',
    ZONE_UPDATED: 'Tsoon on edukalt uuendatud!',
    NEW_ZONE_ADDED: 'Uus tsoon on edukalt lisatud!',
    EDIT_ZONE: 'Muuda tsooni'
  },
  dataTable: { itemsPerPageText: 'Ridu lehel' },
  dataFooter: {
    itemsPerPageAll: 'Kõik',
    prevPage: 'Eelmised',
    nextPage: 'Järgmised'
  },
  ENTER_PASSWORD: 'Sisesta parool',
  REPEAT_PASSWORD: 'Korda parooli',
  ACTIVATE_ACCOUT: 'Aktiveeri oma konto',
  PASSWORD_CRITERIA_MISMATCH:
    'Parool peab sisaldama vähemalt 8 tähemärki, 1 numbrit ja 1 suurt tähte',
  ACCOUNT_ACTIVATED_SUCCESSFULLY:
    'Konto aktiveeritud! Kasutage oma uut parooli, et sisse logida',
  AUTO_GENERATE_PASSWORD: 'Genereeri parool automaatselt',
  PROFILE: 'Profiil',
  SEND_OWNER_INVITE: 'Saada kutse',
  UPDATE_PASSWORD: 'Uuenda parooli',
  SEARCH_BY_VEHICLE: 'Otsi autonumbri järgi',
  BOOKING: {
    CAR_NUMBER: 'Auto',
    START_TIME: 'Algusaeg',
    END_TIME: 'Lõpuaeg',
    NAME: 'Nimi',
    PHONE_NUMBER: 'Telefon',
    EMAIL: 'Email',
    COMMENTS: 'Kommentaar',
    SEARCH_TITLE: 'Broneeringute otsing',
    CLIENT: 'Klient',
    EDIT_BOOKING: 'Muuda broneeringut',
    DELETE_BOOKING: 'Kustuta broneering',
    ADD_NEW: 'Lisa uus broneering',
    STATUS: 'Staatus',
    EXTERNAL_BOOKING_NUMBER: 'Väline broneeringu number',
    DATE_PLACEHOLDER: '31-12-2099',
    TIME_PLACEHOLDER: '23:59',
    START_DATE: 'Algus kuupäev',
    END_DATE: 'Lõpu kuupäev',
    PARKING_STATUS_PARKING: 'Pargib',
    PARKING_STATUS_NOT_PARKING: 'Ei pargi',
    CAR_IS_REQUIRED: 'Auto on nõutud',
    TIME_FORMAT_INCORRECT: 'Ajaformaat peab olema 00:00(TT:MM)',
    DATE_FORMAT_INCORRECT: 'Kuupäevaformaat peab olema 31.01.2024',
    END_BOOKING: 'Lõpeta broneering',
    PUT_SUCCESSFUL: 'Broneering edukalt muudetud',
    ADD_BOOKING: 'Lisa broneering',
    POST_SUCCESSFUL: 'Broneering lisatud edukalt',
    END_BOOKING_DESCRIPTION:
      'Olete lõpetamas broneeringut, kas olete kindel, et soovite broneeringu lõpetada?',
    PARKING_ACTIVE: 'Hetkel pargib',
    PARKING_NOT_ACTIVE: 'Hetkel ei pargi',
    STARTING_BOOKINGS: 'Algavad broneeringud',
    OCCUPANCY_CALENDAR: 'Täituvus kalender',
    ACTIVE_PARKINGS_CURRENTLY: 'Praegu olevad aktiivsed sessioonid',
    COST: 'Hind',
    CREATED_AT: 'Loodud kuupäeval'
  },
  QUICK_ACTIONS: {
    TOOLTIP: 'Kiirvalikud',
    COMMAND_SENT: 'Käsk saadetud',
    COMMAND_FAILED: 'Käsu saatmine ebaõnnestus'
  },
  EDIT_SESSION: 'Muuda sessioon',
  DELETE_SESSION: 'Kustuta sessioon',
  SESSION_WITH_BOOKING: 'Broneeringuga parkimine',
  SET_CURRENT_END_TIMESTAMP: 'Määra lõpu ajatempel praeguseks',
  AUTOMATIC_PAY_AFTER_SAVE: 'Arvuta maksumus automaatselt',
  MAKE_PAYMENT_AFTER_SAVE: 'Algata makse peale salvestamist',
  SEARCH_BY_NAME_OR_EMAIL: 'Otsi nime või emaili järgi',
  VEHICLE_GROUPS: {
    TITLE: 'Autogrupid',
    GROUP_NAME: 'Grupi nimi',
    ADD_NEW: 'Lisa uus',
    EDIT: 'Muuda',
    PUT_SUCCESSFUL: 'Edukalt muudetud',
    POST_SUCCESSFUL: 'Edukalt lisatud',
    LICENSE_PLATES: 'Numbrimärgid',
    LICENSE_PLATE: 'Numbrimärk',
    LICENSE_PLATES_POST_SUCCESSFUL: 'List uuendatud edukalt',
    LICENSE_PLATE_IMPORT_WARNING_MESSAGE:
      'Olete importimas järgnevaid autonumbreid:',
    DELETE_SUCCESSFUL: 'Kustatamine õnnestus',
    LICENSE_PLATE_DELETE_WARNING_MESSAGE: 'Olete kustutamas autonumbrit:',
    ENTER_NEW_LICENSE_PLATE: 'Sisesta uue auto number, formaadis 123ABC',
    REMOVE_EXISTING_VEHICLES: 'Kustuta teised sõidukid'
  },
  ADD_NEW: 'Lisa uus',
  CAR_WASH_DISPUTES: {
    TITLE: 'Vaided',
    CREATED_AT: 'Loodud',
    LICENSE_PLATE: 'Autonumber',
    STATUS: 'Staatus',
    EDIT_DISPUTE: 'Muuda',
    SERVICE_TIME: 'Teenuse kasutamise aeg',
    EDIT: 'Muuda vaiet',
    AMOUNT: 'Summa',
    MESSAGE: 'Sõnum',
    REJECT: 'Lükka tagasi',
    APPROVE: 'Kinnita',
    ALL_DISPUTES: 'Kõik vaided',
    PLACE_NAME: 'Asukoht',
    SERVICE_NAME: 'Teenus'
  },
  SEARCH_BY_PLACE_FLEET_OR_WHITELIST_NAME:
    'Asukoha, külalisgrupi, kasujaloa nimi',
  PRICE: 'Hind',
  FROM_PREVIOUS_MONTH_START: 'Eelmise kuu algusest',
  PREVIOUS_MONTH: 'Eelmine kuu',
  CURRENT_MONTH: 'Jooksev kuu',
  PREVIOUS_WEEK: 'Eelmine nädal',
  CURRENT_WEEK: 'Jooksev nädal',
  YESTERDAY: 'Eile',
  TODAY: 'Täna',
  LAST_7_DAYS: 'Viimased 7 päeva',
  PARKED_MINUTES: 'Pargitud minuteid',
  OVERTIME_MINUTES: 'Üleaeg minutites',
  GATE_CONTROLLERS: {
    ADD_NEW: 'Lisa uus',
    ACTIONS: 'Tegevused',
    RESTART: 'Taaskäivita',
    PIN_STATES: 'Pin olekud',
    OUTPUT_PIN_STATES: 'Väljund pin signaalid',
    LAST_HEARTBEAT: 'Viimane heartbeat',
    SIGNAL_STRENGTH: 'Signaali tugevus',
    OPEN: 'Ava'
  }
}
